import React from 'react'
import {
  IconAgreements, IconPeople,
  IconProducts, IconProjects, IconStores,
  IconDashboard,
  IconStatistics,
  IconViewers,
  IconCard
} from 'assets'

export const getActionTypeIcon = (action: string) => {
  switch (true) {
    case action.includes('user') || action.includes('person'): {
      return <IconPeople />
    }
    case action.includes('agreement'): {
      return <IconAgreements />
    }
    case action.includes('project'): {
      return <IconProjects />
    }
    case action.includes('store') || action.includes('marketplace') || action.includes('brand'): {
      return <IconStores />
    }
    case action.includes('product'): {
      return <IconProducts />
    }
    case action.includes('dashboardSearch'): {
      return <IconDashboard />
    }
    case action.includes('statisticsSearch'): {
      return <IconStatistics />
    }
    case action.includes('viewersSearch'): {
      return <IconViewers />
    }
    case action.includes('create'): {
      return <IconCard />
    }
    default: return null
  }
}
